/* unplugin-vue-components disabled */import { render } from "./lsDetail.vue?vue&type=template&id=2b8a44ba&scoped=true"
import script from "./lsDetail.vue?vue&type=script&lang=js"
export * from "./lsDetail.vue?vue&type=script&lang=js"

import "./lsDetail.vue?vue&type=style&index=0&id=2b8a44ba&scoped=true&lang=css"
import "./lsDetail.vue?vue&type=style&index=1&id=2b8a44ba&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8a44ba"]])

export default __exports__